import { LazyPage, OutcomeDetailPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// The gates live on the layout route above this one.
function OutcomeDetailRoute() {
  return (
    <LazyPage>
      <OutcomeDetailPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/outcomes/$goalId')({
  component: OutcomeDetailRoute,
});
